module.exports = __webpack_public_path__ + "static/media/Silvally_gaussian2.edbe3f9b.png";